export const contactsData = {
    email: 'basic.amir99@gmail.com',
    address: 'Graz, Austria ',

    sheetAPI: ''
}